<template>
    <div class="progress-bar" id="progress-bar">
        <div class="progress-bar-wrapper">
            <div class="prev" @click="goPrevStage()">
                <button type="button">
                        <svg viewBox="0 0 26 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M23.913 16C25.0176 16 25.913 15.1046 25.913 14C25.913 12.8954 25.0176 12 23.913 12V16ZM2 14L0.616189 12.556C0.222567 12.9332 0 13.4548 0 14C0 14.5452 0.222567 15.0668 0.616189 15.444L2 14ZM15.9056 3.44398C16.703 2.67972 16.73 1.41368 15.9657 0.616189C15.2015 -0.181297 13.9354 -0.208234 13.1379 0.556024L15.9056 3.44398ZM13.1379 27.444C13.9354 28.2082 15.2015 28.1813 15.9657 27.3838C16.73 26.5863 16.703 25.3203 15.9056 24.556L13.1379 27.444ZM23.913 12H2V16H23.913V12ZM3.38381 15.444L15.9056 3.44398L13.1379 0.556024L0.616189 12.556L3.38381 15.444ZM0.616189 15.444L13.1379 27.444L15.9056 24.556L3.38381 12.556L0.616189 15.444Z" fill="#575A5D"/>
                        </svg>
                        Назад
                </button>
            </div>
            <div class="progress-line">
                <div class="outer-line">
                    <div class="inner-line" :style="{ width : (getCurrentRouteIndex + 1) * 86 + 'px' }"></div>
                    <div class="inner-line mobile" :style="{ width : (getCurrentRouteIndex + 1) * 6.667 + 'vw' }"></div>
                    <!-- <div class="inner-line" :style="{ width : getCurrentRouteProggres + '%' }"></div> -->
                </div>
            </div>
            <div class="next" @click="goNextStage()">
                <button type="button">
                    Далі
                    <svg viewBox="0 0 26 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.15834 12C1.05377 12 0.158336 12.8954 0.158336 14C0.158336 15.1046 1.05377 16 2.15834 16L2.15834 12ZM24 14L25.3862 15.4417C25.7784 15.0646 26 14.5441 26 14C26 13.4559 25.7784 12.9354 25.3862 12.5583L24 14ZM10.1329 24.5583C9.33665 25.3238 9.31177 26.5899 10.0773 27.3862C10.8429 28.1824 12.109 28.2073 12.9052 27.4417L10.1329 24.5583ZM12.9052 0.55828C12.109 -0.207276 10.8429 -0.182403 10.0773 0.613837C9.31178 1.41007 9.33665 2.67616 10.1329 3.44172L12.9052 0.55828ZM2.15834 16L24 16L24 12L2.15834 12L2.15834 16ZM22.6138 12.5583L10.1329 24.5583L12.9052 27.4417L25.3862 15.4417L22.6138 12.5583ZM25.3862 12.5583L12.9052 0.55828L10.1329 3.44172L22.6138 15.4417L25.3862 12.5583Z" fill="white"/>
                    </svg>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed : {
        ...mapGetters([
            'getCurrentRouteIndex'
        ])
    },
    methods : {
        async goNextStage(){
            console.log('%cMust go to next stage', 'color: orange;')
            this.$store.dispatch('nextStage');
        },
        goPrevStage(){
            this.$store.commit('prevStage');
            // this.$router.go(-1);
        }
    }
}
</script>

<style lang="scss">
.progress-bar{
    position: fixed;
    bottom: 20px;
    left: 20px;

    border-radius: 50px;
    background: #F1F4F5;

    height: 56px;
    width: 96%;     
    
    .progress-bar-wrapper{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        padding: 4px 5px;
    }

    .prev, .next{
        button{
            width: 153px;
            height: 48px;

            border-radius: 100px;
            border: none;

            display: flex;
            align-items: center;

            padding-left: 12px;
            padding-right: 12px;

            font-style: normal;
            font-weight: bold;
            font-size: 16px;
            line-height: 20px;

            text-align: center;

            svg{
                width: 1.074vw;
                height: auto;
            }
        }

        button:focus{
            border: none;
            outline: none;
        }
    }

    .prev{
        button{
            background: #A1C5D0;
            color: #575A5D;

            svg{
                margin-right: 27px;
            }
        }
    }

    .next{
        button{
            justify-content: flex-end;
            background: linear-gradient(270.22deg, #F19100 10.58%, #FB3773 140.06%);
            color: #FFFFFF;

            svg{
                margin-left: 27px;
            }
        }
    }

    .progress-line{
        padding: 0 34px;
        width: 100%;
        overflow: hidden;

        .outer-line{
            height: 8px;
            width: 100%;

            overflow: hidden;

            background: #FFFFFF;
            border: 1px solid rgba(0, 96, 126, 0.2);
            box-sizing: border-box;
            border-radius: 10px;

            .inner-line{
                background: #F9A900;
                height: 100%;

                overflow: hidden;
            }

            .mobile{
                display: none;

                background: #F9A900;
                height: 100%;

                overflow: hidden;
            }
        }
    }
}

@media (min-width: 1024px) and (min-aspect-ratio: 16/9) {
    .progress-bar{
        height: 4.167vw;

        .progress-bar-wrapper{
            padding: 0.417vw;
        }

        .prev, .next{
            button{
                width: 12.917vw;
                height: 3.333vw;

                padding-left: 1.042vw;
                padding-right: 1.042vw;

                font-size: 1.042vw;
                line-height: 1.302vw;
            }
        }

        .prev{
            button{
                svg{
                    margin-right: 2.760vw;

                    height: 1.042vw;
                    width: auto;
                }
            }
        }

        .next{
            button{
                justify-content: flex-end;
                background: linear-gradient(270.22deg, #F19100 10.58%, #FB3773 140.06%);
                color: #FFFFFF;

                svg{
                    margin-left: 2.760vw;

                    height: 1.042vw;
                    width: auto;
                }
            }
        }

        .progress-line{
            padding: 0 2.500vw;

            .outer-line{
                height: 12px;
            }
        }
    }
}

@media (min-width: 1024px) and (min-aspect-ratio: 21/9) {
    .progress-bar{
        height: 3vw;

        .progress-bar-wrapper{
            padding: 0.2vw;
        }

        .prev, .next{
            button{
                width: 8vw;
                height: 2.6vw;

                padding-left: 0.8vw;
                padding-right: 0.8vw;

                font-size: 0.9vw;
                line-height: 1.1vw;
            }
        }

        .prev{
            button{
                svg{
                    margin-right: 1.5vw;

                    height: 0.8vw;
                }
            }
        }

        .next{
            button{
                svg{
                    margin-left: 1.5vw;

                    height: 0.8vw;
                }
            }
        }

        .progress-line{
            padding: 0 2vw;

            .outer-line{
                height: 12px;
            }
        }
    }
}

@media (max-width: 599px){
    .progress-bar{
        margin-left: 10.833vw;
        bottom: 2.222vw;
        left: 2.778vw;

        width: calc(100% - 10.833vw - 2.778vw - 2.778vw);
        height: 10.556vw;

        .progress-bar-wrapper{
            padding: 0.556vw;
        }

        .prev, .next{
            button{
                width: 18.889vw;
                height: 9.444vw;

                padding-left: 2.222vw;
                padding-right: 2.222vw;

                font-size: 2.778vw;
                line-height: 3.889vw;
                
                svg{
                    width: 2.778vw;
                    height: auto;
                }
            }
        }

        .prev{
            button{
                svg{
                    margin-right: 1vw;
                }
            }
        }

        .next{
            button{
                justify-content: flex-end;
                background: linear-gradient(270.22deg, #F19100 10.58%, #FB3773 140.06%);
                color: #FFFFFF;

                svg{
                    margin-left: 1vw;
                }
            }
        }

        .progress-line{
            padding: 0 2.222vw;

            

            .outer-line{
                height: 2.500vw;

                .inner-line{
                    display: none;
                }

                .mobile{
                    display: block;
                }
            }
        }
    }
}
</style>